<script>
  import Button from "./Button.svelte";
  import { getContext } from "svelte";
  import { key } from "../mapbox.js";
  import NUTS from "./NUTS.svelte";
  import Dashboard from "./Dashboard.svelte";

  const { getMap } = getContext(key);
  const map = getMap();

  var APIkey = "anVsaWEuc2FnZXJ0QGdtYWlsLmNvbQ==.6Vj9pq7iN8gZvKfllsR6";
  let draw;
  let showDash;
  let data;
  let nodata;
  let aoi;
  let showDashBtn = false;
  let ShowClose = "Show Dashboard";
  let nutsGeom;
  let nutsURL;
  let carousel, sleft;

  let showClosePoly = false;
  function removePoly() {
    showClosePoly = !showClosePoly;
    map.removeControl(draw)
    document.getElementById("remove").style.visibility = "hidden";
    showDashBtn = false;
    document.getElementById("Poly").disabled = false;
  }
 
  let showNUTS = false;
  let toggleNUTS = () => {
    showNUTS = !showNUTS;
    nutsURL = {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Polygon',
              coordinates: []
            }
          };
    map.getSource("nuts").setData(nutsURL)
  };
  function toggleDash() {
    showDash = !showDash;
    showDashBtn = true;
    if (ShowClose == "Show Dashboard") {
      ShowClose = "Close Dashboard";
    } else {
      ShowClose = "Show Dashboard";
    };
  };
  function drawPolygon() {
    document.getElementById("Poly").disabled = true;
    showClosePoly = !showClosePoly;
    document.getElementById("remove").style.visibility = "visible";
    if (showClosePoly == false) {
      document.getElementById("remove").style.visibility = "hidden";
      map.removeControl(draw);
    };
    draw = new MapboxDraw({
      displayControlsDefault: false,
      defaultMode: "draw_polygon",
      id: "drawing",
    });
    map.on("draw.create", updateBbox);
    map.addControl(draw);
  }

  function updateBbox() {
    let drawnBbox = draw.getAll();

    var nodes = [];
    for (
      var i = 0;
      i < drawnBbox.features[0].geometry.coordinates[0].length;
      i++
    ) {
      nodes.push(drawnBbox.features[0].geometry.coordinates[0][i]);
    }
    
    aoi = {
      geometry: {
        type: "Polygon",
        coordinates: [nodes],
      },
    };
    postPop();
    showDash = true;
    showDashBtn = !showDashBtn;
    ShowClose = "Close Dashboard";
  };

  async function findNUTS(id) {
    nutsURL = "https://api.riscognition.io/nuts/" + id + "?key=" + APIkey
    map.getSource("nuts").setData(nutsURL);
    map.on('style.load', function() {
      map.getSource("nuts").setData(nutsURL)});
    try {
      const res = await fetch(
      nutsURL,
      );
      if (res.status == 200) {
          const data = await res.json();
          nutsGeom = data?.features[0].geometry
          const coords = data?.features[0].geometry.coordinates[0][0];
          return coords;
      } else {
          throw new Error(res.status);
      }
    } catch (error) {
      console.warn(error)            
    };
  };

  async function postPop() {
    data = 0;
    nodata = "";
    const res = await fetch(
      "https://api.riscognition.io/population?key=" + APIkey,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(aoi),
      }
    );
    if (res.status == 200) {
      data = await res.json();
      return;
    }
    else if (res.status == 404) {
      nodata = "Error";
      return;
    }
    throw new Error(res.status);
  };

  async function onPop(event) {
    toggleDash()
    let nodes = await findNUTS(event.detail.nutsID)
    aoi = {
      geometry: {
        type: "Polygon",
        coordinates: [nodes],
      },
    };
    postPop()

    const lng = [];
    const lat = []
    nodes.forEach(element => lng.push(element[0]));
    let minlng = lng.sort()
    minlng = minlng[0]
    let maxlng = lng.reverse()
    maxlng = maxlng[0]
    nodes.forEach(element => lat.push(element[1]));
    let minlat = lat.sort()
    minlat = minlat[0]
    let maxlat = lat.reverse()
    maxlat = maxlat[0]
    let bounds = [[minlng,minlat],[maxlng,maxlat]];
    map.fitBounds(bounds, {padding: 50});
  };

  let showInfo = false;
  function toggleInfo() {
    showInfo = !showInfo;
  }

</script>

{#if showNUTS}
  <NUTS on:close={toggleNUTS} on:accept={onPop}/>
{/if}

{#if showDash}
  <Dashboard data={data} nodata={nodata} on:close={toggleDash} />
{/if}

<div class="tools">
  <Button id="Poly" icon="/assets/polygon.png" active={showClosePoly} on:click={drawPolygon} title="Draw a polygon"/>
  <div class="draw">
    <button type="button" class="remove" id="remove" title="Remove polygon" on:click={removePoly}>X</button>
  </div>
  <Button icon="/assets/nuts.png" active={showNUTS} on:click={toggleNUTS} title="Select NUTS region"/>
  {#if showDashBtn}
      <button class="Dashboard" on:click={toggleDash} title={ShowClose}>{ShowClose}</button>
  {/if}
  <Button icon="/assets/info.png" title="Information" active={showInfo} on:click={toggleInfo}/>
  {#if showInfo}
    <div class="carousel" bind:this={carousel} 
    on:scroll={()=>sleft=carousel.scrollLeft}>
      <div class="info-container">
        <p>Information</p>
        <button type="button" class="close" title="close" on:click={toggleInfo}>x</button>
        <details>
          <summary class="text">Population dataset: <a href="https://ghsl.jrc.ec.europa.eu/download.php?ds=pop" target="_blank">GHSL</a></summary>
          <p class="cite" id="#demo">
            Schiavina, Marcello; Freire, Sergio; MacManus, Kytt (2019):
            <br>
            <a href="http://data.europa.eu/89h/0c6b9751-a71f-4062-830b-43c9f432370f" target="_blank"> GHS population grid multitemporal (1975, 1990, 2000, 2015) R2019A.</a>
            <br>
            European Commission, Joint Research Centre (JRC)
            <br>
            DOI: 10.2905/42E8BE89-54FF-464E-BE7B-BF9E64DA5218
            <br><br>
            Concept & Methodology:<br>
            Freire, Sergio; MacManus, Kytt; Pesaresi, Martino; Doxsey-Whitfield, Erin; Mills, Jane (2016):
            Development of new open and free multi-temporal global population grids at 250 m resolution.
            Geospatial Data in a Changing World; Association of Geographic Information Laboratories in Europe (AGILE). AGILE 2016.
          </p>
        </details>
        <p class="text">
          Icons: <a href="https://www.flaticon.com/" target="_blank">Flaticon</a>
        </p>
        <p class="cite">
          <a href="https://www.flaticon.com/free-icons/polygon" target="_blank">Polygon,</a>
          <a href="https://www.flaticon.com/free-icons/hazelnut" target="_blank">NUTS,</a>
          <a href="https://www.flaticon.com/free-icons/information" target="_blank">Information</a>
        </p>
        <p class="text">
          © 2022 <a href="https://www.riscognition.com/index.html" target="_blank">Riscognition GmbH</a>
        </p>
        <p class="cite">
          <a href="https://www.riscognition.com/imprint.html" target="_blank">Imprint</a> | 
          <a href="https://www.riscognition.com/disclaimer.html" target="_blank">Disclaimer</a> | 
          <a href="https://www.riscognition.com/privacy.html" target="_blank">Privacy</a>
        </p>
      </div>
    </div>
  {/if}
</div>

<style>
  .tools {
    display: flex;
    flex-direction: column;
    
    max-width: 100%;
    position: absolute;
    left: 10px;
    top: 135px;
  }
  .draw {
    display: flex;
    flex-direction: row;
    position: absolute;
    left: 50px;
    top: 0px;
  }
  .Dashboard {
    width: 100px;
    height: 40px;
    left: 10px;
    font-family:Calibri Light, sans-serif;
    font-size:15px;
    border:1px solid #cccccc;
    border-radius:4px;
    box-shadow:1px 1px #dbdbdb;
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:center;
    cursor:pointer;
    margin-bottom:5px;
    background-color:#2A4365;
    color:white
  }
  .remove {
    background-color: #696969;
    color: white;
    cursor: pointer;
    width: 30px;
    height: 100%;
    font-family: Calibri Light, sans-serif;
    font-weight: bold;
    font-size: 18px;
    border-radius: 4px;
    border: solid 1px #cccccc;
    box-shadow: 1px 1px #dbdbdb;
    visibility: hidden;
  }
  .info-container {
    position: relative;
    height: auto;
    max-height: 300px;
    width: auto;
    max-width: 355px;
    left: 50px;
    top: -45px;
    background-color: #F4F4F4;
    border: 2px solid #cccccc;
    border-radius: 4px;
    z-index: 10;
    overflow-y: auto;
    scrollbar-gutter: stable;
  }
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #2A4365;
    border-radius: 100px;
  }
  ::-webkit-scrollbar-track {
    background-color: #cccccc;
  }
  p {
    font-family: Calibri Light, sans-serif;
    font-weight: bold;
    font-size: 20px;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .text {
    font-family: Calibri Light, sans-serif;
    font-size: 15px;
    font-weight: bold;
    text-align: left;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 0;
    margin-top: 15px;
  }
  .cite {
    font-family: Calibri Light, sans-serif;
    font-size: 11px;
    text-align: left;
    margin-left: 25px;
    margin-right: 15px;
    margin-bottom: 10px;
    margin-top: 0;
    text-align: justify;
  }
  a:link, a:visited {
    color: #2A4365;
    text-decoration: underline;
  }
  a:hover {
    color: #2A4365;
    text-decoration: none;
  }
  details summary {
    list-style: none;
  }
  details summary::-webkit-details-marker {
    display: none;
  }
  summary:after {
    content: "◄";
    color: #2A4365;
    float: right;
    margin-right: 140px;
  }
  details[open] summary:after {
    content: "▼";
  }
  .close {
    position: absolute;
    visibility: hidden;
  }

  @media only screen and (max-width: 60em) {
    .info-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      max-width: none;
      max-height: none;
      opacity: 90%;
    }
    .text, .cite {
      margin-left: 30px;
      margin-right: 20px;
    }
    summary:after {
      float: right;
      margin-right: auto;
    }
    .close {
      position: absolute;
      top: 0;
      right: 5px;
      color: #696969;
      cursor: pointer;
      width: 20px;
      height: 20px;
      font-family: Calibri Light, sans-serif;
      font-weight: 900;
      font-size: 20px;
      border: none;
      padding: 0;
      margin: 0;
      text-align: center;
      visibility: visible;
    }
  }

</style>
